import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-03/lesson-17/task-02";
import config from "appConfig";

const task: Slide = {
  title: "Drag and drop the filter elements to the corresponding part of the Formula.",
  description: "",

  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/03/17/task/task-02-figure-01.svg`,
                  styles: {
                    maxWidth: "80%",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task02.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
